import { initChart } from 'vlcishared';
import { DEFAULT_LANGUAGE } from '../common-language';
import { TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL } from './texts';
import { opcionesGraficosActividadComunes } from './common-actividad-administrativa';

/**
 * Modifica el valor de los parámetros del datazoom
 * @param {String} inicio Inicial del datazoom
 * @param {String} fin Final del datazoom
 */
function setValorDataZoom(inicio, fin) {
  Dashboards.setParameter('filterParamFechaInicio', inicio);
  Dashboards.setParameter('filterParamFechaFin', fin);
  Dashboards.fireChange('filterParamFechaInicio');
  Dashboards.fireChange('filterParamFechaFin');
}

export async function echartBarTareasAyuntamiento(datos) {
  const { opcionesGrafica, desagregado } =
    opcionesGraficosActividadComunes(datos);

  // Dar valor a la fecha de inicio y fecha fin inicial
  const firstDateIni =
    desagregado.length >= 8 ? desagregado.at(-8) : desagregado[0];
  const [firstDate, lastDate] = [firstDateIni, desagregado.at(-1)];
  setValorDataZoom(firstDate, lastDate);

  opcionesGrafica.title.subtext = TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get('ayto');
  opcionesGrafica.grid.bottom = 80;
  opcionesGrafica.legend.bottom = 40;  
  opcionesGrafica.xAxis[0].axisLabel = {
    show: true,
    interval: 'auto',
    margin: 5,
    textStyle: {
      fontFamily: 'Montserrat',
      fontSize: 8,
      color: '#333',
    },
  };
  opcionesGrafica.dataZoom[0].startValue = firstDate;
  opcionesGrafica.dataZoom[0].endValue = lastDate;
  opcionesGrafica.dataZoom[0].data = desagregado;
  opcionesGrafica.media = [
    {
      query: {
        maxWidth: 430,
      },
      option: {
        title: {
          textStyle: {
            fontSize: 13,
            width: '265',
          },
          subtextStyle: {
            fontSize: 11,
            lineHeight: 11,
            width: '265',
          },
        },
      },
    },
    {
      query: {
        minWidth: 420,
      },
      option: {
        legend: {
          bottom: 35,
          padding: [0, 10],
          itemWidth: 8,
          itemGap: 10,
          textStyle: {
            fontSize: '12',
          },
        },
      },
    },
    {
      query: {
        minWidth: 670,
      },
      option: {
        legend: {
          itemWidth: 20,
          itemHeight: 10,
          icon: 'roundRect',
        },
      },
    },
    {
      query: {
        minWidth: 700,
      },
      option: {
        title: {
          text: `${TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
            'tareas',
          )} ${TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
            'ayto',
          )}`,
          itemGap: 0,
          top: '10',
          subtext: '',
          textStyle: {
            fontSize: 15,
          },
        },
        legend: {
          bottom: 38,
          padding: [0, 10],
          itemWidth: 8,
          itemGap: 10,
          textStyle: {
            fontSize: '12',
          },
        },
        toolbox: {
          top: '0',
        },
        xAxis: {
          axisLabel: {
            textStyle: {
              fontSize: 10,
            },
          },
        },
        yAxis: [
          {
            axisLabel: {
              textStyle: {
                fontSize: 10,
              },
            },
          },
          {
            axisLabel: {
              textStyle: {
                fontSize: 10,
              },
            },
          },
        ],
      },
    },
    {
      query: {
        minWidth: 950,
      },
      option: {
        grid: {
          bottom: 65,
        },
        series: [
          {
            barMaxWidth: 16,
          },
          {
            barMaxWidth: 16,
          },
        ],
      },
    },
  ];

  const chartInstance = await initChart('chartAyuntamiento', opcionesGrafica);

  // Utilizar datazoom como filtro
  let dataZoomTimeout;
  chartInstance.on('datazoom', () => {
    clearTimeout(dataZoomTimeout);

    dataZoomTimeout = setTimeout(() => {
      // Obtener los valores de start y end
      const dataZoomInfo = chartInstance.getOption().dataZoom[0];
      const startIndex = dataZoomInfo.startValue;
      const endIndex = dataZoomInfo.endValue;
      const selectedXAxis = desagregado.slice(startIndex, endIndex + 1);
      const [first, last] = [selectedXAxis[0], selectedXAxis.at(-1)];

      setValorDataZoom(first, last);
    }, 1000);
  });
}
